import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';
import { IconPipSolid } from '@roku-web-ui/rds-icons';

import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';
import { dispatchEvent } from 'modules/globalEvents';

import { AppDeviceLeaf } from 'types/common/leaf';

interface PictureInPictureProps {
  leafId: AppDeviceLeaf['id'];
  pipEnabled: boolean;
}

export const PictureInPicture = ({ leafId, pipEnabled }: PictureInPictureProps) => {
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title="Picture in Picture" placement="top">
      <IconButton
        aria-label="picture-in-picture"
        data-testid="button-picture-in-picture"
        onClick={() => {
          dispatchEvent({
            leafId,
            event: 'TOGGLE_PIP',
            data: { newValue: !pipEnabled },
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leafId,
              interaction: 'pip',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        <IconPipSolid sx={{ color: pipEnabled ? colors.purple[500] : colors.grey[400] }} />
      </IconButton>
    </Tooltip>
  );
};
